import { TablePageSizeDropdown } from 'components/dropdown/TablePageSizeDropdown';
import { CountDisplay, CountDisplayProps } from 'components/paging/CountDisplay';
import { Paging, PagingProps } from 'components/paging/Paging';
import { MediaQueries } from 'custom_hooks/useWindowSize';
import * as React from 'react';
import styled from 'styled-components';
import { SecondaryText } from 'styles/theme_styles/text';

export const PagingArea = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    grid-template-areas: '. page-selection paging-options';
    margin-top: auto;

    @media ${MediaQueries.smallAndDown} {
        grid-template-columns: 1fr;
        grid-template-rows: 1fr 1fr;
        grid-template-areas:
            'page-selection'
            'paging-options';

        .page-selection {
            justify-self: center;
        }
        .paging-options {
            justify-self: right;
        }
    }
`;

export type PagingBarProps = Pick<
    PagingProps,
    'onPageChange' | 'currentPage' | 'totalPages'
> &
    Pick<CountDisplayProps, 'total' | 'pageSize'> &
    Readonly<{
        /**
         * Whether the page size dropdown should be shown.
         */
        showPageSizeDropdown?: boolean;
        /**
         * Classes to apply to the pagination container.
         */
        className?: string;
        /**
         * Classes to apply to the pagination container.
         */
        style?: React.CSSProperties;
        /**
         * Optional paging options.
         */
        pagingOptions?: Partial<
            Omit<PagingProps, 'onPageChange' | 'currentPage' | 'totalPages'>
        >;
        /**
         * Optional count options.
         */
        countOptions?: Partial<
            Omit<CountDisplayProps, 'currentPage' | 'pageSize' | 'total'>
        >;
    }>;

export function PagingBar({
    onPageChange,
    showPageSizeDropdown,
    currentPage,
    totalPages,
    pageSize,
    total,
    className,
    style,
    pagingOptions,
    countOptions,
}: PagingBarProps) {
    return (
        <PagingArea className={className} style={style}>
            <Paging
                {...pagingOptions}
                totalPages={totalPages}
                onPageChange={onPageChange}
                currentPage={currentPage}
                style={{
                    gridArea: 'page-selection',
                }}
                className="page-selection"
            />
            <div
                className="flex-row justify-flex-end text-right align-center paging-options"
                style={{ gridArea: 'paging-options' }}
            >
                {showPageSizeDropdown && <TablePageSizeDropdown />}
                <SecondaryText>
                    <CountDisplay
                        {...countOptions}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        total={total}
                    />
                </SecondaryText>
            </div>
        </PagingArea>
    );
}
